import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging, DataWithPagingMetadata } from '~/infrastructure/paging';
import {
  StockAdjustCycleCountDetailsModel,
  StockCycleCountChunkDetailModel,
  StockCycleCountChunkModel
} from '~/models/modules/Stocks/Transactions/StockCycleCount/StockCycleCount';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class StockCycleCountAdjustService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  LoadCycleCountChunks(): Observable<StockCycleCountChunkModel[]> {
    return this.client.get<StockCycleCountChunkModel[]>(this._url(`/chuncks`));
  }

  LoadCycleCountChunkVarianceDetails(chunkId: number): Observable<StockCycleCountChunkDetailModel[]> {
    return this.client.get<StockCycleCountChunkDetailModel[]>(this._url(`/variance-details/${chunkId}`));
  }

  AdjustProcess(model: StockAdjustCycleCountDetailsModel): Observable<any> {
    return this.client.post(this._url(`/adjust-process`), model);
  }

  getStockCycleCountAdjustHistory(paramsObj?: any, model?: any): Observable<DataWithPagingMetadata<any>> {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    const params = createHttpParams(paramsObj);

    return this.http
      .post<any[]>(this._url(`/adjust-grid-data`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  private _url(v?: string | undefined): string {
    v = v || '';
    return this.url(`/StockCycleCountAdjustTransaction${v}`);
  }
}
